module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-Hant":{"save":"儲存變更","discard":"捨棄","unsavedChanges":"尚未儲存的變更"},"en":{"save":"Save","discard":"Discard","unsavedChanges":"unsaved changes"}}')
  delete Component.options._Ctor
}
